<label *ngIf="label" [ngClass]="labelClasses" [for]="inputId">
  {{ label | translate }}
</label>
<div class="textarea-wrapper">
  <textarea
    *ngIf="!readonly"
    [ngClass]="inputClasses"
    [value]="value"
    [placeholder]="placeholder"
    [id]="inputId"
    [disabled]="disabled"
    [readonly]="readonly"
    [tabindex]="tabindex"
    [rows]="rows"
    (input)="onInput($event)"
    (blur)="onBlur($event)">
  </textarea>

  <p *ngIf="value && readonly" class="textarea-readonly">
    {{ value }}
  </p>
</div>
